'use client';

import { fetchBlogs } from '@eliadmin/core/src/api/blogs/blogs-api';
import { cn } from '@eliadmin/core/src/utils/style-utils';

import { useInfiniteQuery } from '@tanstack/react-query';
import { CacheKey } from '@eliadmin/core/src/api/constants';

import { Banner } from '../shared/banner';
import { LuArrowUpRight } from 'react-icons/lu';
import { BlogCard } from './blog-card';
import { Button } from '../ui/button';

export const BlogsList = ({ locale }: { locale: string }) => {
  const blogsQuery = useInfiniteQuery({
    queryKey: [CacheKey.BLOGS, locale],
    queryFn: async ({ pageParam = 9 }) => {
      return await fetchBlogs({
        locale,
        query: {
          page: pageParam,
          results: 9,
        },
      });
    },
    getNextPageParam: (lastPage: any, pages) => {
      if (lastPage?.meta?.current_page < lastPage?.meta?.last_page)
        return lastPage?.meta?.current_page + 1;
      return undefined;
    },
    initialPageParam: 1,
  });

  const blogs = blogsQuery.data?.pages.flatMap((page: any) => page.data) ?? [];

  return (
    <section className={cn('custom-section', 'py-20')}>
      <div
        className={cn(
          'custom-container--sm',
          'flex flex-col items-center justify-center gap-10 sm:gap-16 lg:gap-20',
        )}
      >
        {blogsQuery.error && <p className="pt-8 ">Vyskytla sa chyba.</p>}
        {/* {blogsQuery.isLoading && <p className="pt-8 ">Načítavam...</p>} */}
        {blogsQuery.isSuccess && blogs.length > 0 && (
          <div className="flex w-full flex-col items-start justify-start gap-6 xl:gap-12">
            <div className="grid w-full grid-cols-3 gap-6">
              <div className="col-span-3 w-full grid-cols-1 lg:col-span-2">
                <BlogCard blog={blogs[0]} firstBlog />
              </div>
              <div className="col-span-3 grid h-fit w-full grid-cols-1 gap-6 sm:grid-cols-2 lg:col-span-1 lg:grid-cols-1">
                <BlogCard blog={blogs[1]} />
                {blogs.length > 2 && <BlogCard blog={blogs[2]} />}
              </div>
            </div>
            {blogs.length > 3 && (
              <div className="grid w-full grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-2 md:gap-y-8 lg:grid-cols-3">
                {blogs.slice(3).map(blog => (
                  <BlogCard key={blog.slug} blog={blog} />
                ))}
              </div>
            )}

            <div
              className={cn('flex w-full items-center justify-center', {
                hidden: !blogsQuery.hasNextPage,
              })}
            >
              <Button
                onClick={() => blogsQuery.fetchNextPage()}
                isLoading={blogsQuery.isFetchingNextPage}
                className="w-full sm:w-fit"
                variant={'dark'}
              >
                Zobraziť viac
              </Button>
            </div>
          </div>
        )}
        <Banner
          title="Chcem získať cenovú ponuku pre môj projekt"
          isPopup={{
            title: 'Chcem získať cenovú ponuku pre môj projekt',
            variant: 'default',
            icon: (
              <LuArrowUpRight
                size={20}
                className="min-h-10 min-w-10 sm:min-h-12 sm:min-w-12 md:min-h-16 md:min-w-16 lg:min-h-20 lg:min-w-20 xl:min-h-24 xl:min-w-24"
              />
            ),
            className: cn(
              'bg-primary w-full max-h-[240px] flex items-center justify-between text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-[50px] xl:leading-[58px] font-normal text-left text-balance p-6 sm:p-8 lg:p-12 xl:p-16 lg:rounded-[16px]',
            ),
          }}
        />
      </div>
    </section>
  );
};

// const ReferencesSkeleton = () => {
//   return (
//     <div
//       className={cn(
//         'animate-pulse',
//         'col-span-1 grid w-full grid-cols-1 gap-8 sm:col-span-2 sm:grid-cols-2 lg:col-span-3 lg:grid-cols-3 lg:gap-10',
//       )}
//     >
//       <ReferenceSkeletonItem />
//       <ReferenceSkeletonItem />
//       <ReferenceSkeletonItem />
//       <ReferenceSkeletonItem />
//       <ReferenceSkeletonItem />
//     </div>
//   );
// };
